import { ethers } from 'ethers';

const MAX_U64 = ethers.BigNumber.from('18446744073709551615');

/**
 * Withdraw ZKP `nonce` must match the verifier. `AccountCore` is:
 * `(exists, finalized, pending_action, tx_id, elgamal_pubkey, pending_credit_counter, minimum_pending_credit_counter)`.
 * Tuple index `[3]` is `tx_id` (u64); the next ledger operation uses `tx_id + 1` as the proof nonce (u64).
 *
 * @param {readonly unknown[]} accountCoreTuple - `getAccountCore(owner)` return tuple (EVM or Stellar facade)
 * @returns {string} decimal string for JSON (safe for Rust u64 parsing)
 */
export function nextWithdrawProofNonceFromAccountCore(accountCoreTuple) {
    const raw = accountCoreTuple?.[3];
    const txId = ethers.BigNumber.from(raw ?? 0);
    const next = txId.add(1);
    if (next.gt(MAX_U64)) {
        throw new Error('Account tx counter is too large for withdraw proof nonce (u64)');
    }
    return next.toString();
}
